module.exports = "/img/audi.025c14d2.png";